import { render, staticRenderFns } from "./LoginTaipeiPass.vue?vue&type=template&id=20340fd5&scoped=true&"
import script from "./LoginTaipeiPass.vue?vue&type=script&lang=js&"
export * from "./LoginTaipeiPass.vue?vue&type=script&lang=js&"
import style0 from "./LoginTaipeiPass.vue?vue&type=style&index=0&id=20340fd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20340fd5",
  null
  
)

export default component.exports